
import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef,  } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu, } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Chips } from 'primereact/chips';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from "primereact/toast"
import axios from "axios";

const NotesCandidate = forwardRef(({ selectedCustomers }, ref) => {
    const toast = useRef(null)


    // Expose function to parent
    useImperativeHandle(ref, () => ({
        openNotes: () => setVisibleLinkJob(true),
    }));
    // link jobs 

    const [visibleLinkJob, setVisibleLinkJob] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const [valueNotes, setValueNotes] = useState(['Harish']);
    const [popchecked, setPopchecked] = useState(false)

    const handlePopupCheckbox = e => {
        setPopchecked(e.checked)
    }

    const [candidateName, setCandidateName] = useState("Anupam Diridhar, John Doe, Amith, Sagar");
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [userId, setUserId] = useState("Anupam, John, Amith");
    const [notes, setNotes] = useState("");

    const [selectedJobs, setSelectedJobs] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });

    const [searchText, setSearchText] = useState('');
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [selectedJobTitles, setSelectedJobTitles] = useState('');

    const handleIconClick = () => {
        setJobDetailsVisible(true);
    };
    const handleSave = () => {
        const selectedJobTitles = selectedJobs?.map(user => `${user?.first_name ? user?.first_name : ''} ${user?.last_name ? user?.last_name : ''}, ${user?.job_title ? user?.job_title : ''}`).join(" | ");
        setSelectedJobTitles(selectedJobTitles);
        setJobDetailsVisible(false);
    };

    const handleRefresh = () => {
        setSelectedJobs([]);
        setSearchText('');
    };


    const onPageChange = (event) => {
        setLazyParams({ page: event.page, rows: event.rows });
    };

    // link jobs

    const usersList = selectedCustomers?.map(user => `${user?.first_name ? user?.first_name : ''} ${user?.last_name ? user?.last_name : ''}, ${user?.job_title ? user?.job_title : ''}`).join(" | ");

    const getAllActive = async (page, size) => {
        try {
            const endpoint = `/api/v1/candidates/?page=${page + 1}&size=${size}&status=Active`;

            const response = await axios.get(endpoint);
            // const response = await axios.get(`/api/v1/candidates${selectedType ? '/' + selectedType : ''}/?${param ? param + '&' : ''}page=${page + 1}&size=${size}`,);
            if (response?.status === 200) {
                const jobs = response?.data?.results || [];

                const filteredJobs = jobs?.filter(
                    (job) =>
                        job?.first_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
                        job?.job_title?.toLowerCase().includes(searchText?.toLowerCase()) ||
                        job?.email?.toString().includes(searchText)
                );

                setJobs(filteredJobs);
                // setFilteredJobs(response.data.results || []);
                setTotalRecords(response.data.count || 0)
                const transformedData = response?.data?.results?.map((cond) => ({
                    name: cond?.first_name,
                    id: cond?.candidate_id,
                }));
                // settypeInterviewcondi(response.data.results || []);
                const transformedDataemail = response?.data?.results?.map((cond) => ({
                    email: cond?.email,
                    id: cond?.candidate_id,
                }));
                // settoEmail(transformedDataemail)
                // setccEmail(transformedDataemail)
            } else {
                setJobs([]);
                setTotalRecords(0);
            }

        } catch (error) {
            console.error("Failed to fetch candidates", error);
        }
    };

    useEffect(() => {
        getAllActive(lazyParams.page, lazyParams.rows);
    }, [lazyParams]);
    const handleAddNote = async () => {
        try {
            const payload = {
                "candidate_id": selectedCustomers?.length > 0 ? selectedCustomers?.map((candidate) => candidate?.candidate_id).join(",") : selectedJobs?.map((job) => job?.candidate_id).join(","),
                "notes": notes,
                "private": popchecked,
            }
            const response = await axios.post(`/api/v1/notes/`, payload)

            if (response.status === 201) {
                setVisibleLinkJob(false);
                setJobs([]);
                setTotalRecords(0);
                setNotes("");
                setSelectedJobs([]);

                toast.current.show({ severity: 'success', summary: 'Candidate Notes', detail: `Note added successfully` });
            }
        } catch (error) {
            console.error("Failed to fetch candidates", error);
            toast.current.show({ severity: 'error', summary: 'Candidate Notes', detail: `Error adding note` });
        }
    }

    return (
        <React.Fragment>
            <Toast ref={toast} />
            <Tooltip target=".notes" content="Candidates Notes" position="bottom" style={{ marginTop: "5px" }} />

            <button
                type="button"
                className="btn btn-secondary icons-btn me-1 notes"
                //  onClick: () => setVisibleLinkJob(true)
                onClick={() => setVisibleLinkJob(true)}
            >
                <i class="pi pi-file"></i>
            </button>

            <Dialog header={`NOTE - ${usersList}`} visible={visibleLinkJob} onHide={() => setVisibleLinkJob(false)}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">
                                Type
                            </label>
                            <InputText
                                id="candidate"
                                value="Note"
                                readOnly
                                className="w-full"
                                placeholder="Note"
                                disabled
                            />
                        </div>
                    </Col>


                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                                showTime
                                showIcon
                                dateFormat="yy-mm-dd" // Customize the date format
                                hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                                readOnlyInput
                                className="w-full"
                                icon={() => <i className="pi pi-calendar" />}
                            />
                        </div>
                    </Col>

                    {/* <Col lg={12}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">
                                Candidates
                            </label>
                            <InputText
                                id="candidate"
                                value={candidateName}
                                readOnly
                                className="w-full"
                                disabled
                            />
                        </div>
                    </Col> */}

                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">Candidates</label>
                            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                <InputText
                                    id="job"
                                    value={selectedJobTitles}
                                    onChange={(e) => setSelectedJobTitles(e.target.value)}
                                    placeholder={selectedCustomers.length > 0 ? usersList : 'Select Candidates'}
                                    className="w-full"
                                    style={{ paddingRight: '2rem' }} // Ensure space for the icon
                                    disabled={selectedCustomers.length > 0}
                                />
                                {selectedCustomers.length === 0 && (
                                    <i
                                        className="pi pi-chevron-down"
                                        onClick={handleIconClick}
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer'
                                        }}
                                    // disabled={selectedCustomers.length > 0}
                                    ></i>
                                )}


                            </div>
                            <Dialog
                                header="Candidate Details"
                                visible={jobDetailsVisible}
                                onHide={() => setJobDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                {/* Search Bar */}
                                {/* <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Candidates"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }} // Space for the icon
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row> */}

                                {/* DataTable */}
                                <DataTable
                                    value={jobs}
                                    dataKey="candidate_id"
                                    size="small"
                                    selection={selectedJobs}
                                    onSelectionChange={(e) => setSelectedJobs(e.value)}
                                    lazy
                                    paginator
                                    first={lazyParams.page * lazyParams.rows}
                                    rows={lazyParams.rows}
                                    totalRecords={totalRecords}
                                    onPage={onPageChange}
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    rowsPerPageOptions={[10, 20, 50, totalRecords]}
                                >
                                    <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                                    <Column
                                        field="first_name"
                                        header="Candidate Name"
                                        body={(rowData) => `${rowData.first_name} ${rowData.last_name}`}
                                    />
                                    <Column field="job_title" header="Designation" />
                                    <Column field="email" header="Email" />
                                </DataTable>


                                {/* Actions */}
                                <div className="d-flex  mt-3">
                                    {/* <Button label="Save" icon="pi pi-save" onClick={handleSave} />
                                                                                <Button label="Refresh" icon="pi pi-refresh" onClick={handleRefresh} className="p-button-secondary" /> */}
                                    <button type="button" class="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                                    <button type="button" class="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {/* <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy" // Customize the date format
                                hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col> */}

                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">
                                Notes
                            </label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)} // Update the state on input change
                                rows={3} // Number of visible rows
                                cols={20} // Number of visible columns
                                className="w-full"
                                placeholder="Enter your notes here..."
                                autoResize // Automatically adjusts height as content grows
                            />
                        </div>
                    </Col>

                </Row>
                <Row className="align-items-center">
                    <Col lg={2}>
                        <div className="d-flex align-items-center">
                            <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-2 mt-2">
                                Private
                            </label>
                        </div>
                    </Col>
                    {/* <Col lg={6}>
                        <div className="field notes-chip">
                            <label htmlFor="userId" className="block mb-0">
                                User IDs
                            </label>
                            <Chips value={valueNotes} onChange={(e) => setValueNotes(e.value)} className="w-full" />
                        </div>
                    </Col> */}
                </Row>
                <Row>

                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" class="btn btn-primary me-2 btn-main" onClick={handleAddNote}>Add Note</button>
                        </div>
                    </Col>
                </Row>


            </Dialog>


        </React.Fragment>
    );
});


export default NotesCandidate;
